import React, { useState } from 'react';
import './Support.css';

const ISSUE_TYPES = [
  'Wrong hospital information',
  'Wrong summary price',
  'Duplicate hospital',
  'Missing service',
  'Privacy concern',
  'Upload problem',
  'Other'
];

const Support = () => {
  const [issueType, setIssueType] = useState(ISSUE_TYPES[0]);
  const [affectedPage, setAffectedPage] = useState('');
  const [currentValue, setCurrentValue] = useState('');
  const [suggestedValue, setSuggestedValue] = useState('');
  const [note, setNote] = useState('');
  const [status, setStatus] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setStatus(null);

    try {
      const response = await fetch('/api/corrections', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token') || ''}`
        },
        body: JSON.stringify({
          targetType: 'support',
          hospitalName: affectedPage,
          field: issueType,
          currentValue,
          suggestedValue,
          note
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Unable to submit this report.');
      }

      setStatus({ type: 'success', message: 'Thanks. Your report was submitted for review.' });
      setAffectedPage('');
      setCurrentValue('');
      setSuggestedValue('');
      setNote('');
    } catch (error) {
      setStatus({ type: 'error', message: error.message });
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="support-page">
      <section className="support-shell">
        <div className="support-header">
          <p>Support</p>
          <h1>Report an issue or suggest a correction</h1>
          <span>
            Use this for broader problems like wrong hospital details, duplicate hospitals,
            missing services, privacy concerns, or summary prices that look incorrect.
          </span>
        </div>

        <form className="support-card" onSubmit={handleSubmit}>
          {status && (
            <div className={`support-status support-status-${status.type}`} role="status">
              {status.message}
            </div>
          )}

          <label>
            Issue type
            <select value={issueType} onChange={event => setIssueType(event.target.value)}>
              {ISSUE_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
            </select>
          </label>

          <label>
            Page, hospital, or upload affected
            <input
              type="text"
              value={affectedPage}
              onChange={event => setAffectedPage(event.target.value)}
              placeholder="Example: Camino Pet Hospital, Irvine"
              required
            />
          </label>

          <label>
            What looks wrong?
            <input
              type="text"
              value={currentValue}
              onChange={event => setCurrentValue(event.target.value)}
              placeholder="Example: Blood tests summary price"
            />
          </label>

          <label>
            Suggested correction
            <input
              type="text"
              value={suggestedValue}
              onChange={event => setSuggestedValue(event.target.value)}
              placeholder="What should it say instead?"
              required
            />
          </label>

          <label>
            Additional details
            <textarea
              value={note}
              onChange={event => setNote(event.target.value)}
              placeholder="Add any context that would help review this."
              rows="4"
            />
          </label>

          <div className="support-actions">
            <button type="submit" className="next-btn" disabled={saving || !affectedPage.trim() || !suggestedValue.trim()}>
              {saving ? 'Submitting...' : 'Submit report'}
            </button>
          </div>
        </form>
      </section>
    </main>
  );
};

export default Support;
